import * as React from 'react';

import { WithLabelProps } from 'shared/newEntities/components/WithLabel';
import { TagSize, TagType } from 'shared/newEntities/components/Tag';

import './WithLabel.modules.scss';

import Tag from '../Tag';

const WithLabel: React.FC<WithLabelProps> = ({
  children,
  label,
  labelClassName,
  className,
  withIndicator,
  size = TagSize.xs,
  type = TagType.main,
  withIcon
}) => {
  return (
    <div className={className} styleName="container">
      {children}
      <Tag
        size={size}
        type={type}
        withIndicator={withIndicator}
        withIcon={withIcon}
        styleName="container__label"
        className={labelClassName}
      >
        {label}
      </Tag>
    </div>
  );
};

export default React.memo(WithLabel);
